import { render, staticRenderFns } from "./fgtpwd.vue?vue&type=template&id=28cf4555&scoped=true&"
import script from "./fgtpwd.vue?vue&type=script&lang=js&"
export * from "./fgtpwd.vue?vue&type=script&lang=js&"
import style0 from "./fgtpwd.vue?vue&type=style&index=0&id=28cf4555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf4555",
  null
  
)

export default component.exports